import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DatosSocio from "../../generico/DatosSocio"
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import ResumenServices from "../../../services/resumenGeneral/resumenSocioService"
import Select from "react-select";
import Popup from "react-popup";
import { CU24URL } from "../../../components/generico/utils/UrlAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default class ExtractoTC extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tipoTarjeta: "Panal",
      listaMovimientoTarjetaMaster: [],
      listaPeriodo: [],
      periodoElegido: null,
      emisor: null,
      src: null,
      hash: null
    };
  }
  componentDidMount() {
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  //###################### LISTA MES/AÑO ###########################//    

  obtenerListaPeriodo = () => {
    var list = [];
    list.push({
      value: "HOY",
      label: "Extracto a la fecha",
    })
    list.push({
      value: "OTROS",
      label: "Extracto de fechas anteriores",
    })

    var nroTC = sessionStorage.getItem("resumen")
    trackPromise(
      ResumenServices.detalleTC(nroTC, "WEB")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //  console.log(response)
          if (jsonData.codigoRetorno === "0") {

            if (jsonData.resultados === null) {
              this.setState({ hash: null });
              Popup.queue(this.notifiPopup("Info", "No tiene movimientos en la tarjeta"));
              return;
            }

            this.setState({ hash: jsonData.resultados });
          }
          else {
            this.setState({ hash: null });
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
            return;
          }
        }


        ).catch(function (error) {
          authService.logout()
          //console.log(error)
        }));




    this.setState({ listaPeriodo: list });
    return list;
  }

  handleChangePeriodoSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        periodoElegido: null, listaResumen: []
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value
      })
    }
  }

  getListaExtracto() {
    var respuesta = [];
    var datos = [];

    var tipo = sessionStorage.getItem("tipo")


    if (this.state.periodoElegido === null) {
      this.setState({ emisor: null });
      return;
    }


    if (tipo === "Panal") {
      if (this.state.periodoElegido === "HOY") {
        var url = CU24URL + "AccesoCabalEntidades/ReporteMovtosPendientes?prmEmisor=40&prmCripto=" + this.state.hash + "&posVentana=0&prmEmisorProcesador=805";
        this.setState({ emisor: 40, src: url })
      }
      else {
        var url = CU24URL + "AccesoCabalEntidades/ReporteExtractosHB?prmEmisor=40&prmCripto=" + this.state.hash;
        this.setState({ emisor: 40, src: url })
      }
    }
    if (tipo === "Cabal") {
      if (this.state.periodoElegido === "HOY") {
        var url = CU24URL + "AccesoCabalEntidades/ReporteMovtosPendientes?prmEmisor=50&prmCripto=" + this.state.hash + "&posVentana=0&prmEmisorProcesador=805";
        this.setState({ emisor: 50, src: url })
      }
      else {
        var url = CU24URL + "AccesoCabalEntidades/ReporteExtractosHB?prmEmisor=50&prmCripto=" + this.state.hash;
        this.setState({ emisor: 50, src: url })
      }

    }






  }

  dibujarExtracto() {

    return this.dibujarExtractoPanal();

  }

  dibujarExtractoPanal() {
    if (this.state.periodoElegido !== null) {

      return (
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5>Listado de Extracto de Tarjeta</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <iframe src={this.state.src}
                    width="100%" height="300" style={{ border: "none" }}>

                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

  }

  imprimirExtracto(idDiv) {
    var contenido = document.getElementById(idDiv).innerHTML;
    var contenidoOriginal = document.body.innerHTML;
    document.body.innerHTML = contenido;
    window.print();
    document.body.innerHTML = contenidoOriginal;
  }





  render() {
    var list = this.state.listaPeriodo;
    if (this.state.listaPeriodo.length === 0)
      list = this.obtenerListaPeriodo()

    return (
      <div className="content-wrapper">
        <Titulo texto="Extracto de Tarjeta" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{zIndex:1}}>
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                      <label className="input-label-bold">Mes/Año *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangePeriodoSelector}
                            options={list}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                      <button className="btn btn-cu-primary" onClick={() => this.getListaExtracto()} ><FontAwesomeIcon icon={faCheck} /> Consultar</button>

                      </div>
                    </div>
                  </div>
                
                </div>
              </div>
            </div>
            {this.dibujarExtracto()}
          </div>
        </section>
      </div>
    );
  }
}
